import styled from 'styled-components';
import { Typography, Input, Row, Col, Button, Card } from 'antd';

import colors from '../../../../styles/colors';

export const TitleSectionMotorista = styled(Typography.Text)`
  font-weight: 500;
  font-size: 24px;
  line-height: 20px;
  color: #2d3a40;
`;

export const SectionCard = styled(Card)`
  margin-bottom: 28px;
  border: 1px solid ${colors.cinza};
  border-radius: 8px;
  box-shadow: none;

  .ant-card-body {
    padding: 24px;
  }
`;

export const BtnPrimaryColor = styled(Button)`
  background-color: #24a95d !important;
  color: #ffffff !important;
  border-radius: 2px !important;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  border: none;
  height: auto;
  padding: 6px 12px;
  img {
    margin-right: 9px;
  }
  :disabled {
    background-color: #c2ccd1 !important;
  }
`;

export const ModalTitle = styled(Typography.Text)`
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: ${porps => porps.color || colors.primary};
  margin-right: 12px;
`;

export const TextTitleHeader = styled(Typography.Text)`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: ${props => props.color || '#6D787D'};
`;

export const TextHeader = styled(Typography.Text)`
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  margin-right: 6px;
  color: ${props => props.color || '#2d3a40'};
`;

export const CardDocumentos = styled(Col)`
  border-top: 0;
  background: #fff;
  padding: 0 35px 22px 24px;
  border-radius: 0 0 16px 16px;
`;

export const TituloDetalheVeiculo = styled(Typography.Text)`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #2d3a40;
`;

export const TextoDetalheMotorista = styled(Typography.Text)`
  font-weight: ${props => (props.title ? '500' : '400')};
  color: ${props => (props.color || props.title ? '#0D3549' : '#6D787D')};
  font-size: 12px;
  line-height: 20px;
  margin: 0 6px 0 0;
`;

export const TextoCardConsultaOrientacao = styled(Typography.Text)`
  font-weight: 400;
  color: ${props => props.color || '#6D787D'};
  font-size: 12px;
  line-height: 20px;
  margin: 0 6px 0 0;
`;

export const ButtonTypeHeader = styled(Button)`
  color: ${props => props.color || '#2d3a40'};
  border-color: ${props => props.color || '#2d3a40'};
  pointer-events: none;
  border-radius: 4px !important;
  background-color: transparent !important;
`;

export const TextAreaDetalhamento = styled(Input.TextArea)`
  padding: 8px 20px 8px 10px;
  ::-webkit-scrollbar {
    width: 6px;
    border-radius: 8px;
    border: none;
  }

  ::-webkit-scrollbar-track {
    background: #e0e0e0;
    border-radius: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #6d787d;
    border-radius: 8px;
  }
  :disabled {
    background-color: #fff;
  }
`;
